import { AccountingCustomer } from "@wingspanhq/wingspan-api-sdk";

/**
 * Human label for a QuickBooks customer — the v3 counterpart of
 * `getIntegrationUserSelectLabel`, which read v1's `primaryEmailAddress`
 * (a comma-separated list) where v3 carries a single `email`. The email is
 * appended only when the display name doesn't already contain it, so a customer
 * QuickBooks names after their address doesn't read "a@b.com (a@b.com)".
 *
 * Typed on the name/email fields rather than `AccountingCustomer` itself, so an
 * `AccountingVendor` — structurally identical here — labels the same way (v1
 * likewise ran both through one `getIntegrationUserSelectLabel`).
 */
export const selectorAccountingCustomerLabel = (
  customer: Pick<AccountingCustomer, "displayName" | "email" | "companyName">
): string => {
  const email = (customer.email || "").trim();
  const displayName = customer.displayName || customer.companyName || "";

  if (!email || displayName.includes(email)) {
    return displayName;
  }

  return `${displayName} (${email})`;
};
